export default __webpack_public_path__ + "static/media/Domine-Bold.3fb648f6.ttf";